import React, { useRef } from 'react';
import { useLocation } from 'wouter';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; import 'swiper/css/navigation'; import 'swiper/css/pagination';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import '../styles/slider.css';

export interface SlideItem {
  img: string;
  link: string;
}

interface SliderProps {
  items: SlideItem[];
}

const Slider: React.FC<SliderProps> = ({ items }) => {
  const [, navigate] = useLocation();
  const progressCircle = useRef<SVGSVGElement>(null);
  const progressContent = useRef<HTMLSpanElement>(null);

  const onAutoplayTimeLeft = (_: any, time: number, progress: number) => {
    progressCircle.current?.style.setProperty('--progress', (1 - progress).toString());
    if (progressContent.current) {
      progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    }
  };

  return (
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        spaceBetween={30}
        centeredSlides
        autoplay={{ delay: 10000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        navigation
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        className="mySwiper flex items-center justify-center w-full h-full "
      >
        {items.map((item, i) => (
          <SwiperSlide key={i} className="flex items-center justify-center p-2">
            <img
              src={item.img}
              alt={`Slide-${i + 1}`}
              onClick={() => navigate(item.link)}
              className="flex items-center justify-center object-contain cursor-pointer rounded-xl shadow-md shadow-vp-gris"
            />
          </SwiperSlide>
        ))}

        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20" />
          </svg>
          <span ref={progressContent}></span>
        </div>
      </Swiper>
  );
};

export default Slider;
